import {
    IntegratedFiltering,
    IntegratedPaging,
    IntegratedSorting,
    PagingState,
    SortingState,
    TableColumnResizing,
} from '@devexpress/dx-react-grid';
import {
    DragDropProvider,
    Grid,
    PagingPanel,
    Table,
    TableColumnReordering,
    TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import { LinearProgress } from 'material-ui';
import CheckIcon from 'material-ui-icons/Check';
import Paper from 'material-ui/Paper';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from 'react-router-dom/Link';
import { reduxForm } from 'redux-form';
import addEditLocation from '../../../actions/addEditLocation';
import search from '../../../actions/search';
import getReportTypes from '../../../actions/getReportTypes';
import getCustomers from '../../../actions/getCustomers';
import getCustomerGroups from '../../../actions/getCustomerGroups';
import compareCaseInsensitive from '../../../helpers/CompareCaseInsensitive';
import optional from '../../../helpers/OptionalAccess';
import SimpleMenu from '../../../helpers/SimpleMenu';
import SkeletonTableRows from '../../../helpers/SkeletonTableRows';
import TableFilters from '../../../helpers/TableFilters';
import { cacheTableOptions, getTableOptions, filterCustomersByProduct, filterLocationsByProduct, isUserATSysAdmin } from '../../../helpers/Util';
import { ProductMap } from '../../../helpers/ProductMap';
import Layout from '../../Layout';
import { isSysAdmin } from '../../../helpers/security/roles';
import RenderDialog from '../../../helpers/RenderDialog';
import OverflowTip from '../../../helpers/OverflowTip';
import {
    CheckCircle as SuccessIcon,
    Close as CloseIcon,
    Clear as InactiveIcon,
    Search as SearchIcon,
} from '@material-ui/icons';



const componentKey = 'location-list';
const paperStyle = {
    width: '80%',
    height: '70%',
    display: 'inline-block',
    margin: 20,
    marginTop: '4vh'
};


class LocationList extends Component {
    constructor(props) {
        super(props);

        const columns = [
            { name: 'isActive', title: 'Active' },
            { name: 'locationName', title: 'Location' },
            { name: 'autotecId', title: 'AutoTec ID' },
            { name: 'contactName', title: 'Contact Name' },
            { name: 'email', title: 'Email Address' },
            { name: 'city', title: 'Physical City' },
            { name: 'state', title: 'Physical State' },
            { name: 'menu', title: ' ' },
        ];
        const skeletonRows = SkeletonTableRows({ columns: columns, rowKey: 'locationId' });

        this.state = {
            addLink: '/add-edit-location',
            anchorEl: null,
            columns: columns,
            columnOrder: ['locationName', 'autotecId', 'contactName', 'email', 'city', 'state', 'menu'],
            columnWidths: [
                { columnName: 'isActive', width: '7.33%' },
                { columnName: 'locationName', width: '18.35%' },
                { columnName: 'autotecId', width: '9.17%' },
                { columnName: 'contactName', width: '16.51%' },
                { columnName: 'email', width: '16.51%' },
                { columnName: 'city', width: '13.76%' },
                { columnName: 'state', width: '11%' },
                { columnName: 'menu', width: '7.33%' },
            ],
            currentPage: 0,
            customerGroups: [],
            filterByOptions: [
                { name: 'all', label: 'All' },
                { name: 'active', label: 'Active' },
                { name: 'inactive', label: 'Inactive' },
            ],
            initialValues: {},
            loading: false,
            pageSize: 10,
            pageSizes: [5, 10, 0],
            rows: skeletonRows,
            searchByOptions: [
                { name: 'locationName', label: 'Location' },
                { name: 'autotecId', label: 'AutoTec ID' },
                { name: 'contactName', label: 'Contact Name' },
                { name: 'email', label: 'Email Address' },
                { name: 'city', label: 'Physical City' },
                { name: 'state', label: 'Physical State' }
            ],
            sorting: [{ columnName: 'locationName', direction: 'asc' }],
            tableColumnExtensions: [],
            title: 'Locations',
            allItems: [],
            allCustomers: [],
            allLocations: [],
            productFilterOptions: [
                { name: 'all', label: 'All' },
                { name: 'aci', label: 'AutoCheck Insurance' },
                { name: 'aca', label: 'AutoCheck Auctions' },
                { name: 'vxc', label: 'VIN Cross Check' },
            ],
            message: '',
            openDialog: false,
        };
    }

    async componentDidMount() {
        const { customers, config, actions, locationList } = this.props;
        if (customers && locationList && locationList.data.length > 0) {
            await this.getLocationData();
        } else {
            await actions.getLocationItems(config, this);
            await this.getLocationData();
        }
    }

    getLocationData = async () => {
        const { customers, config, actions, locationList } = this.props;
        if (customers && locationList && locationList.data.length > 0) {
            actions.getLocations(config, customers.customers, locationList.data, this);
        }
    }

    componentDidUpdate(prevProps) {
        const { customers, config, actions, locationList } = this.props;
        if (prevProps.locationList !== locationList) {
            if (customers && locationList && locationList.data.length > 0) {
                actions.getLocations(config, customers.customers, locationList.data, this);
            }
        }
    }

    reapplyTableOptions = () => {
        const tableOptions = getTableOptions(componentKey);
        if (!tableOptions) return;

        this.setState({ ...tableOptions });
        this.changeFilters(tableOptions.initialValues);
    };

    rowMapper = (row) => ({
        isActive: (row.isActive === undefined || row.isActive === null) ? true : row.isActive,
        contactName: optional(row, ['contact', 'contactName'], ''),
        email: optional(row, ['contact', 'emailAddress'], ''),
        city: optional(row, ['address', 'city'], ''),
        state: optional(row, ['address', 'state'], ''),
        ...row,
    });

    getRowId = (row) => {
        return row.locationId;
    };

    changeCurrentPage = (currentPage) => {
        cacheTableOptions(componentKey, { currentPage });
        this.setState({ currentPage });
    };

    changePageSize = (pageSize) => {
        cacheTableOptions(componentKey, { pageSize });
        this.setState({ pageSize });
    };

    changeColumnOrder = (columnOrder) => {
        cacheTableOptions(componentKey, { columnOrder });
        this.setState({ columnOrder });
    };

    changeColumnWidths = (columnWidths) => {
        cacheTableOptions(componentKey, { columnWidths });
        this.setState({ columnWidths });
    };

    changeFilters = (filters) => {
        if (!filters) return;
        const isATSysAdmin = isUserATSysAdmin(localStorage.getItem('customerId'));

        const { searchBy, searchData, filterBy, filterByProduct } = filters;

        let filteredLocations = this.state.allItems;
        if (filterByProduct) {
            const filteredCusomers = filterCustomersByProduct(filterByProduct, this.state.allCustomers, localStorage.getItem('customerId'), isATSysAdmin);
            filteredLocations = filterLocationsByProduct(this.state.allLocations, filteredCusomers);
            this.setState({ allItems: filteredLocations });
        }

        let filteredRows = filteredLocations.map(this.rowMapper);

        if (searchBy && searchData) {
            filteredRows = filteredRows
                .filter(cg =>
                    cg[searchBy] &&
                    cg[searchBy].toLowerCase().includes(searchData.toLowerCase())
                );
        }

        if (filterBy && filterBy !== 'all') {
            if (filterBy === 'active') {
                filteredRows = filteredRows.filter(cg => cg.isActive);
            } else if (filterBy === 'inactive') {
                filteredRows = filteredRows.filter(cg => !cg.isActive);
            }
        }

        cacheTableOptions(componentKey, filters);
        this.setState({ rows: filteredRows });
    };

    changeSorting = (sorting) => {
        if (!sorting || !sorting.length) return;

        const sortBy = sorting[0].columnName;
        const sortDirection = sorting[0].direction;
        const sortedRows = [...this.state.rows]
            .sort((a, b) => compareCaseInsensitive(a[sortBy], b[sortBy], sortDirection));

        cacheTableOptions(componentKey, { sorting });
        this.setState({ rows: sortedRows, sorting });
    };

    cell = ({ column, style, tableRow, value }) => {
        if (tableRow.row.isSkeletonRow) {
            return <Table.Cell style={style}>{value}</Table.Cell>;
        }

        let content = <OverflowTip value={value}>{value}</OverflowTip>;

        if (column.name === 'menu') {
            content = this.renderMoreMenu(tableRow);
        } else if (column.name === 'isActive') {
            const className = (value || value === null || value === undefined) ? 'active-1' : 'active-3';
            let active = (value || value === null || value === undefined) ? true : false;
            content = (<Tooltip title={value ? 'Active' : 'Inactive'} placement="left">
                {active ? <CheckIcon className={className} /> : <InactiveIcon className={className} />}
            </Tooltip>);
        }

        return <Table.Cell style={style}>{content}</Table.Cell>;
    };

    renderMoreMenu = (tableRow) => {
        const { row: { locationId, isActive } } = tableRow;

        return (
            <SimpleMenu id={locationId}>
                <MenuItem
                    key="edit-location"
                    component={Link}
                    to={{
                        pathname: `/add-edit-location/${locationId}`,
                        state: { customerId: this.props.match.params.id }
                    }}
                >
                    Edit Location
                </MenuItem>
                <MenuItem
                    key="list-customers-by-location"
                    component={Link}
                    to={`/customers/location/${locationId}`}
                >
                    View Customers
                </MenuItem>
                <MenuItem
                    key="list-users-by-location"
                    component={Link}
                    to={`/users/location/${locationId}`}
                >
                    View Users
                </MenuItem>
                {/* <Divider />
                <MenuItem
                    key="deactivate"
                    component={Link}
                    to={this.props.location.pathname}
                    onClick={() => this.handleToggleIsActive(locationId, isActive)}
                >
                    {isActive ? 'Deactivate' : 'Activate'}
                </MenuItem> */}
            </SimpleMenu>
        );
    };

    handleToggleIsActive = (id, isActive) => {
        const location = this.state.allItems.find(x => x.locationId === id);
        const customer = this.state.allCustomers.find(item => item.customerId === location.customerId);

        if (customer.isActive === false && isActive === false) {
            this.setState({ openDialog: true, message: "Customer account is deactivated" });
        }
        else {
            location.isActive = !isActive;
            this.props.actions.saveLocation(location, this.props.config, this);
        }
    };

    handleClose = () => {
        this.setState({ openDialog: false, message: "" });
    }

    render() {
        const {
            addLink,
            columns,
            columnOrder,
            columnWidths,
            currentPage,
            filterByOptions,
            initialValues,
            loading,
            pageSize,
            pageSizes,
            rows,
            searchByOptions,
            sorting,
            tableColumnExtensions,
            title,
            productFilterOptions,
            message,
            openDialog,
        } = this.state;

        return (
            <Layout
                className="App"
                showMenu
                menuTitle=""
                toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727."
            >
                <Paper style={paperStyle}>
                    {loading && <LinearProgress className="linear-progress-top" />}
                    <Grid
                        rows={rows}
                        columns={columns}
                        getRowId={this.getRowId}
                    >
                        {
                            message !== '' ? <RenderDialog
                                open={openDialog}
                                confirmButton
                                message={message}
                                onClose={this.handleClose}
                            /> : <div />
                        }
                        <TableFilters
                            addLink={addLink}
                            changeFilters={this.changeFilters}
                            filterByOptions={filterByOptions}
                            initialValues={initialValues}
                            searchByOptions={searchByOptions}
                            title={title}
                            productFilterOptions={this.props.person && isSysAdmin(this.props.person) ? productFilterOptions : []}
                        />

                        {filterByOptions && <IntegratedFiltering />}

                        <SortingState
                            sorting={sorting}
                            onSortingChange={this.changeSorting}
                        />

                        <PagingState
                            currentPage={currentPage}
                            onCurrentPageChange={this.changeCurrentPage}
                            pageSize={pageSize}
                            onPageSizeChange={this.changePageSize}
                        />

                        <IntegratedSorting />

                        <IntegratedPaging />

                        <DragDropProvider />

                        <Table
                            columnExtensions={tableColumnExtensions}
                            cellComponent={this.cell}
                        />

                        <TableColumnReordering
                            order={columnOrder}
                            onOrderChange={this.changeColumnOrder}
                        />

                        <TableColumnResizing
                            columnWidths={columnWidths}
                            onColumnWidthsChange={this.changeColumnWidths}
                        />

                        <TableHeaderRow
                            showSortingControls
                        />

                        <PagingPanel pageSizes={pageSizes} />
                    </Grid>
                </Paper>
            </Layout>
        );
    }
}

const reduxToProps = state => ({
    config: state.config.config,
    person: state.person.person,
    customers: state.customers.customers,
    locationList: state.search.locationsList,
});

const dispatchToProps = (dispatch, state) => ({
    actions: {
        getLocationItems: (config, self) => {
            dispatch(getCustomerGroups(config));
            dispatch(search('person-locations', 0, null, config))
            dispatch(search('locations', 0, null, config, true));
            dispatch(getCustomers(config));
            dispatch(search('persons', 0, null, config));
            dispatch(getReportTypes(config));
        },
        getCustomers: (config) => {
            dispatch(getCustomers(config));
        },
        getLocationData: (config) => {
            dispatch(search('locations', 0, null, config, true));
        },
        getLocations: (config, customerItems, locationsList, self) => {
            const { id: pathParamId } = self.props.match.params;
            let rows = [];

            if (pathParamId && pathParamId !== null) {
                self.setState({
                    addLink: `/add-edit-location/customer/${pathParamId}`,
                });
            }

            const product = ProductMap[sessionStorage.getItem('product')];
            const isATSysAdmin = isUserATSysAdmin(localStorage.getItem('customerId'));

            let customers = customerItems;
            self.setState({ allCustomers: customers });

            customers = filterCustomersByProduct(product, customers, localStorage.getItem('customerId'), isATSysAdmin);
            let locations = locationsList;

            if (self.props.location.pathname.includes('/customer/')) {
                locations = locations.filter(r => r.customerId === pathParamId);
                rows = locations.map(self.rowMapper);

                self.setState({ loading: false, allItems: locations, rows }, () => {
                    self.reapplyTableOptions();
                });
            } else if (self.props.location.pathname.includes('/user/')) {
                dispatch(search('person-locations', 0, null, config))
                    .then((personLocationsResult) => {
                        let { items: personLocations } = personLocationsResult.value.data;
                        personLocations = personLocations.filter(pl => pl.personId === pathParamId);

                        locations = locations.filter(l => personLocations.some(pl => pl.locationId === l.locationId));
                        rows = locations.map(self.rowMapper);

                        self.setState({ loading: false, allItems: locations, rows }, () => {
                            self.reapplyTableOptions();
                        });
                    });
            } else {
                self.setState({ allLocations: locations });
                locations = filterLocationsByProduct(locations, customers);
                rows = locations.map(self.rowMapper);

                self.setState({ loading: false, allItems: locations, rows }, () => {
                    self.reapplyTableOptions();
                });
            }
            self.setState({ loading: false });
        },
        saveLocation: (location, config, self) => {
            self.setState({ loading: true });

            dispatch(addEditLocation(location, config))
                .then(() => {
                    dispatch(search('locations', 0, null, config, true));
                });
        },
    }
});

const ConnectedComponent = connect(reduxToProps, dispatchToProps)(LocationList);

export default (reduxForm({ form: 'LocationList' })(ConnectedComponent));


// WEBPACK FOOTER //
// ./src/components/Customer/Location/LocationList.js